import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-brand">
              <img src="/KM01.png" alt="Kenny Miles Exchange Logo" className="brand-logo" />
              <span>Kenny Miles Exchange</span>
            </div>
            <p>
              Your trusted platform for secure trading, backed by innovation and excellence.
            </p>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/trading">Trading</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/reviews">Reviews</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Contact Info</h3>
            <div className="contact-item">
              <Mail className="contact-icon" />
              <a href="mailto:kennymilesexchange3@gmail.com">support@kennymilesexchange.com</a>
            </div>
            <div className="contact-item">
              <Phone className="contact-icon" />
              <a href="tel:+2348095732028">+234 (809) 5732028</a>
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a 
                href="https://www.linkedin.com/in/okechukwu-kennedy-88b347306?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" 
                className="social-link" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
              <a 
                href="https://wa.me/2348095732028?text=Hi,%20Kenny%20Miles%20Exchange" 
                className="social-link" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
              <a 
                href="https://www.instagram.com/kenny_milesexchange?utm_source=qr&igsh=NnQxNnlyajE4eDBh" 
                className="social-link" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Instagram
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Kenny Miles Exchange. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
